import React, { createContext, useContext, useState, useCallback } from "react";

interface StylesUpdateContextType {
  updateTrigger: number;
  triggerUpdate: () => void;
}

const StylesUpdateContext = createContext<StylesUpdateContextType | undefined>(
  undefined
);

export const useStylesUpdate = (): StylesUpdateContextType => {
  const context = useContext(StylesUpdateContext);
  if (!context) {
    throw new Error(
      "useStylesUpdate must be used within a StylesUpdateProvider"
    );
  }
  return context;
};

export const StylesUpdateProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [updateTrigger, setUpdateTrigger] = useState(0);

  const triggerUpdate = useCallback(() => {
    setUpdateTrigger((prev) => prev + 1);
  }, []);

  return (
    <StylesUpdateContext.Provider value={{ updateTrigger, triggerUpdate }}>
      {children}
    </StylesUpdateContext.Provider>
  );
};
